
<template>
  <!-- 表单内容 -->
  <div class="form-container">
    <div class="logo-wrapper">
      <img class="logo-img" :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'">
    </div>


    <h1 class="form-title">{{ $t("login.title") }}</h1>
    <p class="form-subtitle">{{$t("欢迎回到越南彩票")}}</p>

      <!-- 账号输入框 -->
      <div class="input-group">
        <label for="username">{{$t("账户名称")}}</label>
        <div class="input-wrapper">
          <img src="/img/login/account.jpg" class="icon">
          <input type="text" id="username" v-model="username" :placeholder="$t('输入帐户名称')" >
        </div>
      </div>

      <!-- 密码输入框 -->
      <div class="input-group">
        <label for="password">{{$t("密码")}}</label>
        <div class="input-wrapper">
          <img src="/img/login/lock.jpg" class="icon">
          <input  :type="passwordType" id="password" v-model="password" :placeholder="$t('输入密码')" >
          <img src="/img/login/eye-off.jpg" v-if="passwordType === 'password'" class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType">
          <img src="/img/login/eye.jpg" v-else class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType">
        </div>
      </div>

      <!-- 记住登录与忘记密码 -->
      <div class="options-row">

        <div class="remember-me"  @click="rememberFun()">
          <input type="checkbox" :checked="remember" >
          {{$t("记住登录")}}
        </div>
        <div class="forgot-password" v-if="false" @click="service">{{$t("忘记密码？")}}</div>
      </div>

      <!-- 登录按钮 -->
      <button type="button"  class="login-btn" @click="doLogin">{{$t("login.doLogin")}}</button>

      <!-- 分割线与注册 -->
      <div class="divider">{{$t("没有帐户？")}}</div>
      <button type="button" class="register-btn" @click="toRegister">{{$t("立即注册")}}</button>

  </div>

</template>

<script>

export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      username: '',
      password: this.inputValue,
      passwordType: 'password',
      remember: false,
    };
  },
  methods: {
    rememberFun(){
        this.remember = !this.remember;
    },
    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },

    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    toRegister(){
      this.$router.push("Register")
    },
    doLogin() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast(this.$t('login.username')+"!");
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast(this.$t('login.password')+"!");
        return false;
      }
      this.$http({
        method: 'get',
        data:{username:this.username,password:this.password},
        url: 'member_login'
      }).then(res=>{
        console.log(res);
        if(res.code === 200){
          if(this.remember){
            localStorage.setItem('username',this.username)
            localStorage.setItem('password',this.password)
            localStorage.setItem('remember',this.remember)
          }else{
            localStorage.removeItem('username');
            localStorage.removeItem('password');
            localStorage.removeItem('remember');
          }
          this.$toast.success(this.$t("msg."+res.msg));

          localStorage.setItem('token1',res.data.token)
          localStorage.setItem('token',res.data.id)
          this.$router.push("Mine")
        }else {
          this.$toast(this.$t("msg."+res.msg));
        }
      })
    }
  },
  created() {

    this.username = localStorage.getItem('username');
    this.password = localStorage.getItem('password');
    this.remember = localStorage.getItem('remember');

    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.logo-wrapper{
  margin: 0 auto;
  width: 45%;
}
.logo-wrapper .logo-img{
  width: 100%;
  margin-top: 40px;
}
.icon{
  width: 20PX;
  margin-right: 8PX;
}
/* 表单区域 */
.form-container {
  padding: 30PX 24PX;
  flex: 1;
  overflow-y: auto;
}

.form-title {
  text-align: center;
  font-size: 22PX;
  font-weight: bold;
  color: #333;
  margin-bottom: 8PX;
}

.form-subtitle {
  text-align: center;
  font-size: 14PX;
  color: #666;
  margin-bottom: 30PX;
}

.input-group {
  margin-bottom: 20PX;
  position: relative;
}

.input-group label {
  display: block;
  font-size: 14PX;
  font-weight: 500;
  color: #333;
  margin-bottom: 8PX;
}

.input-wrapper {
  display: flex;
  align-items: center;
  border: 1PX solid #ddd;
  border-radius: 8PX;
  padding: 0 12PX;
  background-color: #fff;
  height: 48PX;
}

.input-wrapper i {
  color: #999;
  font-size: 16PX;
  margin-right: 10PX;
}

.input-wrapper input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14PX;
  color: #333;
}

.input-wrapper input::placeholder {
  color: #aaa;
}

.password-toggle {
  cursor: pointer;
}

/* 记住登录和忘记密码 */
.options-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25PX;
  font-size: 13PX;
  padding: 0 4PX;
}

.remember-me {
  display: flex;
  align-items: center;
  color: #555;
  cursor: pointer;
}

.remember-me input[type="checkbox"] {
  margin-right: 6PX;
  accent-color: #d8000f;
  width: 16PX;
  height: 16PX;
}

.forgot-password {
  color: #007bff;
  text-decoration: none;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  background-color: #d8000f;
  color: white;
  border: none;
  padding: 14PX;
  border-radius: 8PX;
  font-size: 16PX;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 25PX;
  transition: background-color 0.2s;
}

.login-btn:hover {
  background-color: #c0000d;
}

/* 分割线和注册区域 */
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #999;
  font-size: 13PX;
  margin-bottom: 20PX;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1PX solid #ddd;
}

.divider:not(:empty)::before {
  margin-right: .5em;
}

.divider:not(:empty)::after {
  margin-left: .5em;
}

.register-btn {
  width: 100%;
  background-color: #fff;
  color: #d8000f;
  border: 1PX solid #d8000f;
  padding: 14PX;
  border-radius: 8PX;
  font-size: 16PX;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.register-btn:hover {
  background-color: #fff5f5;
}

/* 右下角悬浮按钮 */
.fab-btn {
  position: absolute;
  bottom: 20PX;
  right: 20PX;
  width: 44PX;
  height: 44PX;
  background-color: #e0e0e0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 18PX;
  cursor: pointer;
  box-shadow: 0 2PX 8PX rgba(0,0,0,0.15);
}
</style>
